/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const PauseIcon = createIcon(
  '0 0 20 20',
  <path d="M8 3H4v14h4zm8 0h-4v14h4z" />,
);
